<template>
  <form action="#">
    <slot/>
  </form>
</template>

<script>
export default {
  name: "UiForm",
  props: {
    errors: {
      type: Object,
      default: () => {
      }
    },
    store: {
      type: String,
      default: null,
    }
  }
}
</script>
